// import React, { useEffect, useState } from 'react';
// import { collection, getDocs } from 'firebase/firestore';
// import { db } from '../firebase/firebase'; // Adjust the import according to your Firebase setup
// import Skeleton from '@mui/material/Skeleton'; // Import Skeleton
// import styles from './FeaturedProduct.module.css'; // Import CSS Module
// import { motion } from 'framer-motion'; // Import Framer Motion

// const FeaturedProduct = () => {
//   const [product, setProduct] = useState(null);
//   const [quantity, setQuantity] = useState(1); // State for quantity
//   const [selectedImage, setSelectedImage] = useState(0); // State for selected image index
//   const [isLoading, setIsLoading] = useState(true); // State for loading

//   useEffect(() => {
//     const fetchProduct = async () => {
//       try {
//         const querySnapshot = await getDocs(collection(db, 'featuredProduct'));
//         querySnapshot.forEach((doc) => {
//           setProduct(doc.data());
//         });
//       } catch (error) {
//         console.error('Error fetching product:', error);
//       } finally {
//         setIsLoading(false); // Set loading to false after data is fetched
//       }
//     };

//     fetchProduct();
//   }, []);

//   // Handle quantity increase
//   const increaseQuantity = () => {
//     setQuantity((prev) => prev + 1);
//   };

//   // Handle quantity decrease
//   const decreaseQuantity = () => {
//     if (quantity > 1) {
//       setQuantity((prev) => prev - 1);
//     }
//   };

//   // Handle thumbnail click
//   const handleThumbnailClick = (index) => {
//     setSelectedImage(index); // Update selected image index
//   };

//   if (isLoading) {
//     return (
//       <div className={styles.container}>
//         {/* Image on the left side - Skeleton */}
//         <div className={styles.imageContainer}>
//           <Skeleton variant="rectangular" width="100%" height={400} className={styles.mainImage} />
//           {/* Thumbnail Images - Skeleton */}
//           <div className={styles.thumbnailContainer}>
//             {[1, 2, 3].map((_, index) => (
//               <Skeleton
//                 key={index}
//                 variant="rectangular"
//                 width={80}
//                 height={80}
//                 className={styles.thumbnailImage}
//               />
//             ))}
//           </div>
//         </div>

//         {/* Product details on the right side - Skeleton */}
//         <div className={styles.detailsContainer}>
//           <div>
//             <Skeleton variant="text" width="90%" height={40} className={styles.title} />
//             <Skeleton variant="text" width="70%" height={30} className={styles.price} />

//             {/* Quantity Selector - Skeleton */}
//             <div className={styles.mb6}>
//               <Skeleton variant="text" width="30%" height={20} className={styles.quantityLabel} />
//               <div className={styles.flexItemsCenter}>
//                 <Skeleton variant="rectangular"  height={40} className={`${styles.quantityButtonLeft} ${styles.skeletonBackground}`} />
//                 <Skeleton variant="rectangular"  height={50} className={styles.quantityInput} />
//                 <Skeleton variant="rectangular"  height={40} className={`${styles.quantityButtonRight} ${styles.skeletonBackground}`}  />
//               </div>
//             </div>
//           </div>

//           {/* Buttons - Skeleton */}
//           <div className={styles.flexColSpaceY4}>
//             <Skeleton variant="rectangular" width="93%" height={40} className={styles.addToCartButton} />
//             <Skeleton variant="rectangular" width="93%" height={40} className={`${styles.buyNowButton} ${styles.skeletonBackground}`} />
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!product) {
//     return <div>Product not found!</div>;
//   }

//   return (
//     <motion.div
//       className={styles.container}
//       initial={{ opacity: 0, y: 50 }} // Initial animation state
//       whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//       viewport={{ once: false }} // Animate only once
//       transition={{ duration: 0.5 }} // Animation duration
//     >
//       {/* Image on the left side */}
//       <motion.div
//         className={styles.imageContainer}
//         initial={{ opacity: 0, x: -50 }} // Initial animation state
//         whileInView={{ opacity: 1, x: 0 }} // Animate when in view
//         viewport={{ once: false }} // Animate only once
//         transition={{ duration: 0.5, delay: 0.2 }} // Animation duration and delay
//       >
//         {/* Main Image */}
//         <motion.img
//           className={styles.mainImage}
//           src={product.imageUrl[selectedImage]} // Display selected image
//           alt={product.title}
//           initial={{ opacity: 0, scale: 0.9 }} // Initial animation state
//           whileInView={{ opacity: 1, scale: 1 }} // Animate when in view
//           viewport={{ once: false }} // Animate only once
//           transition={{ duration: 0.5, delay: 0.4 }} // Animation duration and delay
//         />

//         {/* Thumbnail Images */}
//         <motion.div
//           className={styles.thumbnailContainer}
//           initial={{ opacity: 0, y: 20 }} // Initial animation state
//           whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//           viewport={{ once: false }} // Animate only once
//           transition={{ duration: 0.5, delay: 0.6 }} // Animation duration and delay
//         >
//           {product.imageUrl.map((image, index) => (
//             <motion.img
//               key={index}
//               className={`${styles.thumbnailImage} ${
//                 index === selectedImage ? styles.active : ''
//               }`}
//               src={image}
//               alt={`Thumbnail ${index + 1}`}
//               onClick={() => handleThumbnailClick(index)} // Change main image on click
//               whileHover={{ scale: 1.1 }} // Hover effect
//               whileTap={{ scale: 0.9 }} // Tap effect
//               initial={{ opacity: 0, y: 20 }} // Initial animation state
//               whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//               viewport={{ once: false }} // Animate only once
//               transition={{ duration: 0.3, delay: index * 0.1 }} // Animation duration and delay
//             />
//           ))}
//         </motion.div>
//       </motion.div>

//       {/* Product details on the right side */}
//       <motion.div
//         className={styles.detailsContainer}
//         initial={{ opacity: 0, x: 50 }} // Initial animation state
//         whileInView={{ opacity: 1, x: 0 }} // Animate when in view
//         viewport={{ once: false }} // Animate only once
//         transition={{ duration: 0.5, delay: 0.8 }} // Animation duration and delay
//       >
//         <div>
//           {/* Title */}
//           <motion.div
//             className={styles.title}
//             initial={{ opacity: 0, y: 20 }} // Initial animation state
//             whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//             viewport={{ once: false }} // Animate only once
//             transition={{ duration: 0.5, delay: 1 }} // Animation duration and delay
//           >
//             {product.title}
//           </motion.div>

//           {/* Price */}
//           <motion.p
//             className={styles.price}
//             initial={{ opacity: 0, y: 20 }} // Initial animation state
//             whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//             viewport={{ once: false }} // Animate only once
//             transition={{ duration: 0.5, delay: 1.2 }} // Animation duration and delay
//           >
//             Rs. {product.price}
//           </motion.p>

//           {/* Quantity Selector */}
//           <motion.div
//             className={styles.mb6}
//             initial={{ opacity: 0, y: 20 }} // Initial animation state
//             whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//             viewport={{ once: false }} // Animate only once
//             transition={{ duration: 0.5, delay: 1.4 }} // Animation duration and delay
//           >
//             <label htmlFor="quantity" className={styles.quantityLabel}>Quantity</label>
//             <div className={styles.flexItemsCenter}>
//               <motion.button
//                 className={styles.quantityButtonLeft}
//                 onClick={decreaseQuantity}
//                 whileHover={{ scale: 1.1 }} // Hover effect
//                 whileTap={{ scale: 0.9 }} // Tap effect
//               >
//                 -
//               </motion.button>
//               <motion.input
//                 type="text"
//                 className={styles.quantityInput}
//                 value={quantity}
//                 readOnly
//                 initial={{ opacity: 0, scale: 0.9 }} // Initial animation state
//                 whileInView={{ opacity: 1, scale: 1 }} // Animate when in view
//                 viewport={{ once: false }} // Animate only once
//                 transition={{ duration: 0.5, delay: 1.6 }} // Animation duration and delay
//               />
//               <motion.button
//                 className={styles.quantityButtonRight}
//                 onClick={increaseQuantity}
//                 whileHover={{ scale: 1.1 }} // Hover effect
//                 whileTap={{ scale: 0.9 }} // Tap effect
//               >
//                 +
//               </motion.button>
//             </div>
//           </motion.div>
//         </div>

//         {/* Buttons */}
//         <motion.div
//           className={styles.flexColSpaceY4}
//           initial={{ opacity: 0, y: 20 }} // Initial animation state
//           whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//           viewport={{ once: false }} // Animate only once
//           transition={{ duration: 0.5, delay: 1.8 }} // Animation duration and delay
//         >
//           <motion.button
//             className={styles.addToCartButton}
//             whileHover={{ scale: 1.05 }} // Hover effect
//             whileTap={{ scale: 0.95 }} // Tap effect
//           >
//             Add to Cart
//           </motion.button>
//           <motion.button
//             className={styles.buyNowButton}
//             whileHover={{ scale: 1.05 }} // Hover effect
//             whileTap={{ scale: 0.95 }} // Tap effect
//           >
//             Buy it now
//           </motion.button>
//         </motion.div>
//       </motion.div>
//     </motion.div>
//   );
// };

// export default FeaturedProduct;




// import React, { useEffect, useState } from 'react';
// import { fetchCollection } from './fetchUtils'; // Import the generic utility function
// import Skeleton from '@mui/material/Skeleton'; // Import Skeleton
// import styles from './FeaturedProduct.module.css'; // Import CSS Module
// import { motion } from 'framer-motion'; // Import Framer Motion
// import { useFeaturedProduct } from './FeaturedProductContext';

// const FeaturedProduct = () => {
//   const { product, isLoading } = useFeaturedProduct(); // Use global context
//   const [quantity, setQuantity] = useState(1); // State for quantity
//   const [selectedImage, setSelectedImage] = useState(0); // State for selected image index

//   // Handle quantity increase
//   const increaseQuantity = () => {
//     setQuantity((prev) => prev + 1);
//   };

//   // Handle quantity decrease
//   const decreaseQuantity = () => {
//     if (quantity > 1) {
//       setQuantity((prev) => prev - 1);
//     }
//   };

//   // Handle thumbnail click
//   const handleThumbnailClick = (index) => {
//     setSelectedImage(index); // Update selected image index
//   };

//   if (isLoading) {
//     return (
//       <div className={styles.container}>
//         {/* Image on the left side - Skeleton */}
//         <div className={styles.imageContainer}>
//           <Skeleton variant="rectangular" width="100%" height={400} className={styles.mainImage} />
//           {/* Thumbnail Images - Skeleton */}
//           <div className={styles.thumbnailContainer}>
//             {[1, 2, 3].map((_, index) => (
//               <Skeleton
//                 key={index}
//                 variant="rectangular"
//                 width={80}
//                 height={80}
//                 className={styles.thumbnailImage}
//               />
//             ))}
//           </div>
//         </div>

//         {/* Product details on the right side - Skeleton */}
//         <div className={styles.detailsContainer}>
//           <div>
//             <Skeleton variant="text" width="90%" height={40} className={styles.title} />
//             <Skeleton variant="text" width="70%" height={30} className={styles.price} />

//             {/* Quantity Selector - Skeleton */}
//             <div className={styles.mb6}>
//               <Skeleton variant="text" width="30%" height={20} className={styles.quantityLabel} />
//               <div className={styles.flexItemsCenter}>
//                 <Skeleton variant="rectangular" height={40} className={`${styles.quantityButtonLeft} ${styles.skeletonBackground}`} />
//                 <Skeleton variant="rectangular" height={50} className={styles.quantityInput} />
//                 <Skeleton variant="rectangular" height={40} className={`${styles.quantityButtonRight} ${styles.skeletonBackground}`} />
//               </div>
//             </div>
//           </div>

//           {/* Buttons - Skeleton */}
//           <div className={styles.flexColSpaceY4}>
//             <Skeleton variant="rectangular" width="93%" height={40} className={styles.addToCartButton} />
//             <Skeleton variant="rectangular" width="93%" height={40} className={`${styles.buyNowButton} ${styles.skeletonBackground}`} />
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!product) {
//     return <div>Product not found!</div>;
//   }

//   return (
//     <motion.div
//       className={styles.container}
//       initial={{ opacity: 0, y: 50 }} // Initial animation state
//       whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//       viewport={{ once: false }} // Animate only once
//       transition={{ duration: 0.5 }} // Animation duration
//     >
//       {/* Image on the left side */}
//       <motion.div
//         className={styles.imageContainer}
//         initial={{ opacity: 0, x: -50 }} // Initial animation state
//         whileInView={{ opacity: 1, x: 0 }} // Animate when in view
//         viewport={{ once: false }} // Animate only once
//         transition={{ duration: 0.5, delay: 0.2 }} // Animation duration and delay
//       >
//         {/* Main Image */}
//         <motion.img
//           className={styles.mainImage}
//           src={product.imageUrl[selectedImage]} // Display selected image
//           alt={product.title}
//           initial={{ opacity: 0, scale: 0.9 }} // Initial animation state
//           whileInView={{ opacity: 1, scale: 1 }} // Animate when in view
//           viewport={{ once: false }} // Animate only once
//           transition={{ duration: 0.5, delay: 0.4 }} // Animation duration and delay
//         />

//         {/* Thumbnail Images */}
//         <motion.div
//           className={styles.thumbnailContainer}
//           initial={{ opacity: 0, y: 20 }} // Initial animation state
//           whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//           viewport={{ once: false }} // Animate only once
//           transition={{ duration: 0.5, delay: 0.6 }} // Animation duration and delay
//         >
//           {product.imageUrl.map((image, index) => (
//             <motion.img
//               key={index}
//               className={`${styles.thumbnailImage} ${
//                 index === selectedImage ? styles.active : ''
//               }`}
//               src={image}
//               alt={`Thumbnail ${index + 1}`}
//               onClick={() => handleThumbnailClick(index)} // Change main image on click
//               whileHover={{ scale: 1.1 }} // Hover effect
//               whileTap={{ scale: 0.9 }} // Tap effect
//               initial={{ opacity: 0, y: 20 }} // Initial animation state
//               whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//               viewport={{ once: false }} // Animate only once
//               transition={{ duration: 0.3, delay: index * 0.1 }} // Animation duration and delay
//             />
//           ))}
//         </motion.div>
//       </motion.div>

//       {/* Product details on the right side */}
//       <motion.div
//         className={styles.detailsContainer}
//         initial={{ opacity: 0, x: 50 }} // Initial animation state
//         whileInView={{ opacity: 1, x: 0 }} // Animate when in view
//         viewport={{ once: false }} // Animate only once
//         transition={{ duration: 0.5, delay: 0.8 }} // Animation duration and delay
//       >
//         <div>
//           {/* Title */}
//           <motion.div
//             className={styles.title}
//             initial={{ opacity: 0, y: 20 }} // Initial animation state
//             whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//             viewport={{ once: false }} // Animate only once
//             transition={{ duration: 0.5, delay: 1 }} // Animation duration and delay
//           >
//             {product.title}
//           </motion.div>

//           {/* Price */}
//           <motion.p
//             className={styles.price}
//             initial={{ opacity: 0, y: 20 }} // Initial animation state
//             whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//             viewport={{ once: false }} // Animate only once
//             transition={{ duration: 0.5, delay: 1.2 }} // Animation duration and delay
//           >
//             Rs. {product.price}
//           </motion.p>

//           {/* Quantity Selector */}
//           <motion.div
//             className={styles.mb6}
//             initial={{ opacity: 0, y: 20 }} // Initial animation state
//             whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//             viewport={{ once: false }} // Animate only once
//             transition={{ duration: 0.5, delay: 1.4 }} // Animation duration and delay
//           >
//             <label htmlFor="quantity" className={styles.quantityLabel}>Quantity</label>
//             <div className={styles.flexItemsCenter}>
//               <motion.button
//                 className={styles.quantityButtonLeft}
//                 onClick={decreaseQuantity}
//                 whileHover={{ scale: 1.1 }} // Hover effect
//                 whileTap={{ scale: 0.9 }} // Tap effect
//               >
//                 -
//               </motion.button>
//               <motion.input
//                 type="text"
//                 className={styles.quantityInput}
//                 value={quantity}
//                 readOnly
//                 initial={{ opacity: 0, scale: 0.9 }} // Initial animation state
//                 whileInView={{ opacity: 1, scale: 1 }} // Animate when in view
//                 viewport={{ once: false }} // Animate only once
//                 transition={{ duration: 0.5, delay: 1.6 }} // Animation duration and delay
//               />
//               <motion.button
//                 className={styles.quantityButtonRight}
//                 onClick={increaseQuantity}
//                 whileHover={{ scale: 1.1 }} // Hover effect
//                 whileTap={{ scale: 0.9 }} // Tap effect
//               >
//                 +
//               </motion.button>
//             </div>
//           </motion.div>
//         </div>

//         {/* Buttons */}
//         <motion.div
//           className={styles.flexColSpaceY4}
//           initial={{ opacity: 0, y: 20 }} // Initial animation state
//           whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//           viewport={{ once: false }} // Animate only once
//           transition={{ duration: 0.5, delay: 1.8 }} // Animation duration and delay
//         >
//           <motion.button
//             className={styles.addToCartButton}
//             whileHover={{ scale: 1.05 }} // Hover effect
//             whileTap={{ scale: 0.95 }} // Tap effect
//           >
//             Add to Cart
//           </motion.button>
//           <motion.button
//             className={styles.buyNowButton}
//             whileHover={{ scale: 1.05 }} // Hover effect
//             whileTap={{ scale: 0.95 }} // Tap effect
//           >
//             Buy it now
//           </motion.button>
//         </motion.div>
//       </motion.div>
//     </motion.div>
//   );
// };

// export default FeaturedProduct;



import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton'; // Import Skeleton
import styles from './FeaturedProduct.module.css'; // Import CSS Module
import { motion } from 'framer-motion'; // Import Framer Motion
import { useCollection } from './GenericContext'; // Import useCollection hook
import { useNavigate } from 'react-router-dom';
import { useCart } from '../AddToCart/CartContext';
import CartDrawer from '../AddToCart/CartDrawer';

const FeaturedProduct = () => {
  const navigate = useNavigate();
  // const collectionName = "featuredProduct"; // Define collectionName here
  // const collectionName = "featuredProduct"; // Define collectionName here
  // const { data: product, isLoading } = useCollection(collectionName); // Pass collectionName
  const { data: product, isLoading } = useCollection(); // Use the generic context
  const [quantity, setQuantity] = useState(1); // State for quantity
  const [selectedImage, setSelectedImage] = useState(0); // State for selected image index
  const { addToCart } = useCart();

  // State to control the cart drawer visibility
  const [isCartOpen, setIsCartOpen] = useState(false);

  // Handle quantity increase
  const increaseQuantity = () => {
    setQuantity((prev) => prev + 1);
  };

  // Handle quantity decrease
  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  // Handle thumbnail click
  const handleThumbnailClick = (index) => {
    setSelectedImage(index); // Update selected image index
  };

  const handleProductClick = (id) => {
    navigate(`/product_detail/${id}`);
  };

  // const handleAddToCart = () => {
  //   if (product) {
  //     addToCart({
  //       id: product.id,
  //       imageUrl: product.imageUrl,
  //       title: product.title,
  //       price: product.price,
  //       quantity: quantity, // Use the selected quantity
  //     });
  //     // alert(`${product.title} added to cart!`);
  //     alert(`${quantity} ${product.title}(s) added to cart!`); 
  //   }
  // };
  const handleAddToCart = () => {
    if (product) {
      for (let i = 0; i < quantity; i++) {
        addToCart({
          // id: product.id,
          // imageUrl: product.imageUrl,
          // title: product.title,
          // price: product.price,
          // name:product.name,
          ...product,
          quantity: 1, // Always add 1 at a time
        });
      }
      // alert(`${quantity} ${product.title}(s) added to cart!`); // Show the quantity added
      setIsCartOpen(true); // Open the cart drawer
    }
  };

  const handleBuyNow = () => {
    if (product) {
      addToCart({
        // id: product.id,
        // imageUrl: product.imageUrl,
        // title: product.title,
        // price: product.price,
        // name:product.name,
        ...product,
        quantity: quantity, // Use the selected quantity
      });
      navigate(`/shopnow`);
      // alert(`${product.title} added to cart!`);
      // alert(`${quantity} ${product.title}(s) added to cart!`); 
    }
  };
  

  if (isLoading) {
    return (
      <div className={styles.container}>
        {/* Image on the left side - Skeleton */}
        <div className={styles.imageContainer}>
          <Skeleton variant="rectangular" width="100%" height={400} className={styles.mainImage} />
          {/* Thumbnail Images - Skeleton */}
          <div className={styles.thumbnailContainer}>
            {[1, 2, 3].map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                width={80}
                height={80}
                className={styles.thumbnailImage}
              />
            ))}
          </div>
        </div>

        {/* Product details on the right side - Skeleton */}
        <div className={styles.detailsContainer}>
          <div>
            <Skeleton variant="text" width="90%" height={40} className={styles.title} />
            <Skeleton variant="text" width="70%" height={30} className={styles.price} />
            <Skeleton variant="text" width="70%" height={30} className={styles.discountPrice} />

            {/* Quantity Selector - Skeleton */}
            <div className={styles.mb6}>
              <Skeleton variant="text" width="30%" height={20} className={styles.quantityLabel} />
              <div className={styles.flexItemsCenter}>
                <Skeleton variant="rectangular" height={40} className={`${styles.quantityButtonLeft} ${styles.skeletonBackground}`} />
                <Skeleton variant="rectangular" height={50} className={styles.quantityInput} />
                <Skeleton variant="rectangular" height={40} className={`${styles.quantityButtonRight} ${styles.skeletonBackground}`} />
              </div>
            </div>
          </div>

          {/* Buttons - Skeleton */}
          <div className={styles.flexColSpaceY4}>
            <Skeleton variant="rectangular" width="93%" height={40} className={styles.addToCartButton} />
            <Skeleton variant="rectangular" width="93%" height={40} className={`${styles.buyNowButton} ${styles.skeletonBackground}`} />
          </div>
        </div>
      </div>
    );
  }

  if (!product) {
    return <div>Product not found!</div>;
  }

  return (
    <>
    <motion.div
      className={styles.container}
      initial={{ opacity: 0, y: 50 }} // Initial animation state
      whileInView={{ opacity: 1, y: 0 }} // Animate when in view
      viewport={{ once: false  }} // Animate only once
      transition={{ duration: 0.5 }} // Animation duration
    >
      {/* Image on the left side */}
      <motion.div
        className={styles.imageContainer}
        initial={{ opacity: 0, x: -50 }} // Initial animation state
        whileInView={{ opacity: 1, x: 0 }} // Animate when in view
        viewport={{ once: false  }} // Animate only once
        transition={{ duration: 0.5, delay: 0.2 }} // Animation duration and delay
      >
        {/* Main Image */}
        <motion.img
        onClick={() => handleProductClick(product.id)}
          className={styles.mainImage}
          src={product.imageUrl[selectedImage]} // Display selected image
          alt={product.title}
          // src={product?.imageUrl?.[selectedImage] || 'fallback-image.jpg'} 
          // alt={product?.title || 'Product Image'}
          initial={{ opacity: 0, scale: 0.9 }} // Initial animation state
          whileInView={{ opacity: 1, scale: 1 }} // Animate when in view
          viewport={{ once: false  }} // Animate only once
          // transition={{ duration: 0.5, delay: 0.4 }} // Animation duration and delay
          whileHover={{ scale: 1.05 }} // Scale image on hover
          transition={{ duration: 0.8 }}
        />

        {/* Thumbnail Images */}
        <motion.div
          className={styles.thumbnailContainer}
          initial={{ opacity: 0, y: 20 }} // Initial animation state
          whileInView={{ opacity: 1, y: 0 }} // Animate when in view
          viewport={{ once: false  }} // Animate only once
          transition={{ duration: 0.5, delay: 0.6 }} // Animation duration and delay
        >
          {product.imageUrl.map((image, index) => (
            <motion.img
              key={index}
              className={`${styles.thumbnailImage} ${
                index === selectedImage ? styles.active : ''
              }`}
              src={image}
              alt={`Thumbnail ${index + 1}`}
              onClick={() => handleThumbnailClick(index)} // Change main image on click
              whileHover={{ scale: 1.1 }} // Hover effect
              whileTap={{ scale: 0.9 }} // Tap effect
              initial={{ opacity: 0, y: 20 }} // Initial animation state
              whileInView={{ opacity: 1, y: 0 }} // Animate when in view
              viewport={{ once: false  }} // Animate only once
              transition={{ duration: 0.3, delay: index * 0.1 }} // Animation duration and delay
            />
          ))}
        </motion.div>
      </motion.div>

      {/* Product details on the right side */}
      <motion.div
        className={styles.detailsContainer}
        initial={{ opacity: 0, x: 50 }} // Initial animation state
        whileInView={{ opacity: 1, x: 0 }} // Animate when in view
        viewport={{ once: false  }} // Animate only once
        transition={{ duration: 0.5, delay: 0.8 }} // Animation duration and delay
      >
        <div>
          {/* Title */}
          <motion.div
            className={styles.title}
            initial={{ opacity: 0, y: 20 }} // Initial animation state
            whileInView={{ opacity: 1, y: 0 }} // Animate when in view
            viewport={{ once: false  }} // Animate only once
            transition={{ duration: 0.5, delay: 1 }} // Animation duration and delay
          >
            {product.title}
          </motion.div>

          {/* Price */}
          <motion.div
            className={styles.priceContainer}
            initial={{ opacity: 0, y: 20 }} // Initial animation state
            whileInView={{ opacity: 1, y: 0 }} // Animate when in view
            viewport={{ once: false  }} // Animate only once
            transition={{ duration: 0.5, delay: 1.2 }} // Animation duration and delay
          >
            {/* Rs. {product.price} */}
                  {product.discountPrice && product.discountPrice > 0 ? (
                    <div className={styles.priceDiscountPrice}>
                      <p className={styles.price}>
                        Rs. {product.price}
                      </p>
                      <p>
                        Rs. {product.discountPrice}
                      </p>
                    </div>
                  ) : (
                        <p className={styles.discountPrice}>
                          Rs.{product.price}
                        </p>
                      )}
          </motion.div>

          {/* Quantity Selector */}
          <motion.div
            className={styles.mb6}
            initial={{ opacity: 0, y: 20 }} // Initial animation state
            whileInView={{ opacity: 1, y: 0 }} // Animate when in view
            viewport={{ once: false  }} // Animate only once
            transition={{ duration: 0.5, delay: 1.4 }} // Animation duration and delay
          >
            <label htmlFor="quantity" className={styles.quantityLabel}>Quantity</label>
            <div className={styles.flexItemsCenter}>
              <motion.button
                className={styles.quantityButtonLeft}
                onClick={decreaseQuantity}
                whileHover={{ scale: 1.1 }} // Hover effect
                whileTap={{ scale: 0.9 }} // Tap effect
              >
                -
              </motion.button>
              <motion.input
                type="text"
                className={styles.quantityInput}
                value={quantity}
                readOnly
                initial={{ opacity: 0, scale: 0.9 }} // Initial animation state
                whileInView={{ opacity: 1, scale: 1 }} // Animate when in view
                viewport={{ once: false  }} // Animate only once
                transition={{ duration: 0.5, delay: 1.6 }} // Animation duration and delay
              />
              <motion.button
                className={styles.quantityButtonRight}
                onClick={increaseQuantity}
                whileHover={{ scale: 1.1 }} // Hover effect
                whileTap={{ scale: 0.9 }} // Tap effect
              >
                +
              </motion.button>
            </div>
          </motion.div>
        </div>

        {/* Buttons */}
        <motion.div
          className={styles.flexColSpaceY4}
          initial={{ opacity: 0, y: 20 }} // Initial animation state
          whileInView={{ opacity: 1, y: 0 }} // Animate when in view
          viewport={{ once: false  }} // Animate only once
          transition={{ duration: 0.5, delay: 1.8 }} // Animation duration and delay
        >
          <motion.button
            className={styles.addToCartButton}
            whileHover={{ scale: 1.05 }} // Hover effect
            whileTap={{ scale: 0.95 }} // Tap effect
            onClick={handleAddToCart}
          >
            Add to Cart
          </motion.button>
          <motion.button
            className={styles.buyNowButton}
            whileHover={{ scale: 1.05 }} // Hover effect
            whileTap={{ scale: 0.95 }} // Tap effect
            onClick={handleBuyNow}
          >
            Buy it now
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
    {/* Cart Drawer */}
    <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
};

export default FeaturedProduct;

